export interface HIDDeviceFound
{
    collections: HIDCollection[],
    productId: number,
    productName: string,
    vendorId: number,
    opened: boolean
}

export interface HIDCollection { reportIds: number[], usage: number, usagePage: number }
export interface HIDDeviceFilter { vendorId: number, productId: number, usagePage: number, usage: number }
export interface HIDRequestDeviceOptions { filters: HIDDeviceFilter[] }
export interface HIDReport { reportId: number, data: string }
export interface HIDOpResult { success: boolean, message: string, hidDevicesFound: HIDDeviceFound[] | undefined }

export function ParseHIDDevice(rawDevice: any): HIDDeviceFound 
{
    return {
        collections: [], // Do we need collection support?
        productId: rawDevice.productId,
        productName: rawDevice.productName,
        vendorId: rawDevice.vendorId,
        opened: rawDevice.opened
    };
}

export function HIDDeviceKey(device: HIDDeviceFound): string
{
    return `${device.productName}${device.productId}${device.vendorId}`;
}
